module.exports = __webpack_public_path__ + "img/06董磊.f53b88a9.jpg";